import { NavLink, useLocation } from "react-router-dom";
import { useCustomHook } from "../../../../globalComponents/GlobalFunctions/globalFunctions";
import { ReactComponent as NotificationIcon } from "../../../../assets/icons/Notification.svg";
import { useSelector } from "react-redux";

const SidebarWorker = ({ closeSidebar, profiles }) => {
  const location = useLocation();
  const { generalProfileList } = useCustomHook();
  const { hasNewNotification } = useSelector((state) => state.notifications);

  const groupsNav = ["/groups/current", "/groups/waiting", "/groups/ended"];

  const isActive = (profile) => {
    if (profile === "groups") {
      return groupsNav.includes(location.pathname) ? "active" : "";
    } else {
      return "";
    }
  };

  return (
    <ul className="sidebar-nav-list">
      <li>
        <NavLink to="/notifications" onClick={closeSidebar}>
          <div style={{ position: "relative" }}>
            {hasNewNotification > 0 && (
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#ed444e",
                  position: "absolute",
                  right: "8px",
                  top: "-2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "8px", color: "white" }}>
                  {hasNewNotification}
                </span>
              </div>
            )}
            <NotificationIcon />
          </div>
          Bildirişlər
        </NavLink>
      </li>
      {generalProfileList.map((data) => {
        const { name, key, icon, id } = data;
        
        const checkProfile = profiles.find((item) => item.profile === key);

        if (checkProfile) {
          return (
            <li key={id}>
              <NavLink
                className={isActive(key)}
                to={
                  key === "groups"
                    ? `/${key}/waiting`
                    : key === "salaries"
                      ? `/teachers-payments`
                      : key === "quarterlyPlan"
                        ? "quarterly-plan"
                        : key === "tuitionFee"
                          ? "/tuition-fee"
                          : key === "segmentation"? "/workers-plan" : key 
                }
                onClick={closeSidebar}
              >
                <span key={id}>
                  {icon}
                  {name}
                </span>
              </NavLink>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default SidebarWorker;
